import React from "react";
import { isValidDate } from "../../utils/datetime";
import { useTranslation } from "react-i18next";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";

export const onChangeValidation = ({
  t,
  setFieldValue,
  setFieldError,
  name,
  date,
  onChange
}) => {
  if (date && !isValidDate(date)) {
    setFieldError(name, t("validationMessages.validDate"));
  } else {
    setFieldError(name, "");
    if (onChange) {
      onChange(date);
    }
  }
  setFieldValue(name, date, false);
  return date;
};

const DatePickerField = ({
  field,
  form,
  label,
  onAccept,
  onBlur,
  minDate,
  maxDate,
  variant,
  fullWidth,
  disabled,
  dataQa,
  InputClassName,
  inputDataTestId,
  inputDataQa,
  onChange
}) => {
  const currentError = form.submitCount > 0 && form.errors[field.name];
  const { t } = useTranslation();
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        clearable
        name={field.name}
        value={field.value}
        format="MM/dd/yyyy"
        onChange={date =>
          onChangeValidation({
            t: t,
            setFieldError: form.setFieldError,
            setFieldValue: form.setFieldValue,
            name: field.name,
            date: date,
            onChange
          })
        }
        minDate={minDate}
        maxDate={maxDate}
        onAccept={onAccept}
        disabled={disabled}
        renderInput={params => (
          <TextField
            variant={variant}
            fullWidth={fullWidth}
            {...params}
            helperText={currentError}
            error={Boolean(currentError)}
            hiddenLabel={!label}
            label={label}
            onBlur={onBlur}
            disabled={disabled}
            data-qa={dataQa}
            InputProps={{
              className: InputClassName,
              ...params.InputProps
            }}
            inputProps={{
              "aria-labelledby": `date-picker-${field.name}`,
              "data-testid": inputDataTestId,
              "data-qa": inputDataQa,
              ...params.inputProps,
              error: currentError
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default DatePickerField;

DatePickerField.defaultProps = {
  variant: "filled",
  fullWidth: true
};
